import { COLORS } from "./design-constants";

export const COLOR_TOKENS = {
  MAIN: {
    primary:   COLORS.NEUTRAL["900"],
    secondary: COLORS.NEUTRAL["600"],
    disabled:  COLORS.NEUTRAL["300"],
    neutral:   COLORS.NEUTRAL["100"],
    link:      COLORS.TURQUOISE["400"],
    brand:     COLORS.GOLD["300"],
    white:     COLORS.WHITE["900"],
    black:     COLORS.BLACK["700"],
  },

  TECHNICAL: {
    warning:      COLORS.YELLOW["200"],
    warningDark:  COLORS.YELLOW["400"],
    warningLight: COLORS.YELLOW["50"],
    info:         COLORS.BLUE["500"],
    infoLight:    COLORS.BLUE["50"],
    success:      COLORS.GREEN["400"],
    successLight: COLORS.GREEN["50"],
    error:        COLORS.RED["500"],
    errorLight:   COLORS.RED["50"],
    neutral:      COLORS.NEUTRAL["600"],
    neutralLight: COLORS.NEUTRAL["50"],
  },

  BACKGROUND: {
    white:         COLORS.WHITE["900"],
    page:          COLORS.NEUTRAL["25"],
    idle:          COLORS.NEUTRAL["25"],
    hover:         COLORS.NEUTRAL["50"],
    hoverSubtle:   COLORS.NEUTRAL["25"],
    selected:      COLORS.NEUTRAL["100"],
    hoverNegative: COLORS.NEUTRAL["700"],
  },

  ACTION: {
    active:             "rgba(255, 255, 255, 0.54)",
    hover:              "rgba(255, 255, 255, 0.90)",
    hoverReversed:      "rgba(255, 255, 255, 0.10)",
    pressed:            "rgba(255, 255, 255, 0.76)",
    pressedReversed:    "rgba(255, 255, 255, 0.24)",
    selected:           "rgba(255, 255, 255, 0.92)",
    disabled:           "rgba(255, 255, 255, 0.54)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    focus:              "rgba(255, 255, 255, 0.12)",
  },

  STROKE: {
    divider: COLORS.NEUTRAL["100"],
    idle:    COLORS.NEUTRAL["400"],
    error:   COLORS.RED["500"],
  },

  INFOGRAPHICS: {
    boldRed:           COLORS.RED["500"],
    boldRedLight:      COLORS.RED["50"],
    deepOrange:        COLORS.ORANGE["400"],
    deepOrangeLight:   COLORS.ORANGE["50"],
    softPeach:         COLORS.ORANGE["200"],
    softPeachLight:    COLORS.ORANGE["50"],
    brightYellow:      COLORS.YELLOW["200"],
    brightYellowLight: COLORS.YELLOW["50"],
    tropicalGreen:     COLORS.GREEN["300"],
    tropicalGreenLight:COLORS.GREEN["50"],
    aquaCyan:          COLORS.TURQUOISE["200"],
    aquaCyanLight:     COLORS.TURQUOISE["50"],
    skyBlue:           COLORS.BLUE["400"],
    skyBlueLight:      COLORS.BLUE["50"],
    darkSteel:         COLORS.NEUTRAL["600"],
    darkSteelLight:    COLORS.NEUTRAL["50"],
    vibrantPurple:     COLORS.PURPLE["600"],
    vibrantPurpleLight:COLORS.PURPLE["50"],
    electricMagenta:   COLORS.PINK["500"],
    electricMagentaLight: COLORS.PINK["50"],
  },
} as const;
